// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.locations.location', {
        url: '/{locationId}',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/locations/location/location.tpl.html',
                controller: 'ContactsLocationController as vm'
            }
        },
        resolve: {
            location: locationResolver,
            users: usersResolver,
            addressTypes: addressTypesResolver,
            contactInfoTypes: contactInfoTypesResolver,
            userLocations: userLocationsResolver,
            pricelists: pricelistsResolver
        }
    });
}

// @ngInject
function locationResolver($stateParams,LocationsApiService) {
    return LocationsApiService.getLocation($stateParams.locationId);
}

// @ngInject
function usersResolver(LocationsApiService) {
    return LocationsApiService.getUsers();
}

// @ngInject
function userLocationsResolver(LocationsApiService) {
    return LocationsApiService.getUserLocations();
}

// @ngInject
function addressTypesResolver(LocationsApiService) {
    return LocationsApiService.getAddressTypes();
}

// @ngInject
function contactInfoTypesResolver(LocationsApiService) {
    return LocationsApiService.getContactInfoTypes();
}

// @ngInject
function pricelistsResolver(LocationsApiService) {
    return LocationsApiService.getPricelists();
}

// @ngInject
function ContactsLocationController(location, users, addressTypes, contactInfoTypes, LocationsApiService, ToasterService, loadSpinnerService, userLocations, AuthService, currentUser, pricelists) {
    var vm = this;

    vm.allowUpdate = false;
    vm.isEditing = false;
    vm.selectedLocation = location;
    vm.selectedLocationCopy = angular.copy(location);
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactLocationView') === 'true';
    vm.reactLocationId = location && location.id != null ? location.id : null;
    vm.users = users;
    vm.addressTypes = addressTypes;
    vm.contactInfoTypes = contactInfoTypes;
    vm.userLocations = userLocations;
    vm.priceLists = pricelists;

    vm.newAddress = {};
    vm.newContactInfo = {};

    vm.startEditing = startEditing;
    vm.cancelEditing = cancelEditing;
    vm.save = save;

    vm.addNewContactInfo = addNewContactInfo;
    vm.updateContactInfo = updateContactInfo;
    vm.deleteContactInfo = deleteContactInfo;

    vm.addNewAddress = addNewAddress;
    vm.updateAddress = updateAddress;
    vm.deleteAddress = deleteAddress;
    vm.allowSaveLocation = allowSaveLocation;
    vm.isAllowedToSetAutoOrder = false;

    activate();

    function activate() {
        vm.priceLists.unshift({id: 0, pricelistName: '-'});
        vm.allowUpdate = AuthService.matchAnyDemand(
            {location: { update: true }},
            currentUser.claims
        );
        vm.isAllowedToSetAutoOrder = AuthService.matchAnyDemand(
            {stocklogistics: { update: true }},
            currentUser.claims
        );
    }

    function allowSaveLocation() {

        if (!vm.allowUpdate) {
            return false;
        }

        if (userLocations.length === 0 || _.includes(userLocations, vm.selectedLocation.id)) {
            return true;
        }

        return false;
    }

    function startEditing() {
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.selectedLocation = angular.copy(vm.selectedLocationCopy);
        vm.isEditing = false;
    }

    function save() {
        loadSpinnerService.start('mainSpinner');
        LocationsApiService.updateLocation(vm.selectedLocation).then(function(response) {
            vm.selectedLocation = response;
            vm.selectedLocationCopy = angular.copy(vm.selectedLocation);
            vm.isEditing = false;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });

    }

    function removeContactInfo(contactInfo) {
        vm.selectedLocation.contactInfos.splice(_.findIndex(vm.selectedLocation.contactInfos,{contactInfoType:{typeName:contactInfo.contactInfoType.typeName}}),1);
        resetTypes();
    }

    function resetTypes() {
        vm.newAddress = {};
        vm.newContactInfo = {};
    }

    function addNewContactInfo(contactInfo) {
        vm.selectedLocation.contactInfos.push(contactInfo);
    }

    function addNewAddress(address) {
        vm.selectedLocation.addresses.push(address);
    }

    function updateAddress(address) {
        var addressToUpdate = _.find(vm.selectedLocation.addresses, function(addr) { return addr.id === address.id; });
        if (addressToUpdate !== undefined) {
            addressToUpdate.addressLine1 = address.addressLine1;
            addressToUpdate.addressLine2 = address.addressLine2;
            addressToUpdate.addressLine3 = address.addressLine3;
            addressToUpdate.postalcode = address.postalcode;
            addressToUpdate.city = address.city;
            addressToUpdate.country = address.country;
        }
    }

    function deleteAddress(address) {
        var addressToUpdate = _.find(vm.selectedLocation.addresses, function(addr) { return addr.id === address.id; });
        if (addressToUpdate !== undefined) {
            vm.selectedLocation.addresses = _.without(vm.selectedLocation.addresses, addressToUpdate);
        }
    }

    function updateContactInfo(contactInfo) {
        var infoToUpdate = _.find(vm.selectedLocation.contactInfos, function(ci) { return ci.id === contactInfo.id; });
        if (infoToUpdate !== undefined) {
            infoToUpdate.value = contactInfo.value;
            infoToUpdate.contactInfoType = contactInfo.contactInfoType;
        }
    }

    function deleteContactInfo(contactInfo) {
        var infoToUpdate = _.find(vm.selectedLocation.contactInfos, function(ci) { return ci.id === contactInfo.id; });
        if (infoToUpdate !== undefined) {
            vm.selectedLocation.contactInfos = _.without(vm.selectedLocation.contactInfos, infoToUpdate);
        }
    }

}

angular.module('contacts.locations.location', [])
    .config(stateConfig)
    .controller('ContactsLocationController', ContactsLocationController);
